import React from 'react';
import { DocumentPlusIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import CompetitorType from '@app/model/company_hotel/CompetitorType';
import _isEmpty from 'lodash/isEmpty';
import Utilities from '@util/Utilities';
import Dialogue from '@app/component/overlays/dialog/Dialogue';
import useDialogue from '@app/component/overlays/dialog/DialogueRef';
import {
	useRemoveCompanyHotelCompetitorsGroupMutation,
} from '@app/model/company_hotel/service/CompanyHotelServiceHooks';


const FlexiSetsPage = React.memo(() => {

	const { companyHotel } = useSelectedCompanyHotel();

	const competitorGroups = companyHotel.findCompetitorsByType(CompetitorType.GROUP);
	const deleteDialogue = useDialogue<number>();

	const removeCompanyHotelCompetitorsGroupMutation = useRemoveCompanyHotelCompetitorsGroupMutation();

	const onRemoveCompanyHotelCompetitorsGroup = (competitorsGroupId: number) => {
		removeCompanyHotelCompetitorsGroupMutation.mutate({ companyHotelId: companyHotel.id, competitorsGroupId });
	};

	return <main>
		{/* Content */}
		<div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
			{!_isEmpty(competitorGroups) &&
				<div className="mx-auto mt-8 space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none bg-white p-6 sm:p-10 rounded-xl">
					<div>
						<div className="sm:flex sm:items-center">
							<div className="sm:flex-auto">
								<h1 className="text-base font-semibold leading-6 text-gray-900">My FlexiSets</h1>
								<p className="text-sm leading-6 text-gray-500">
									Add your sets to better track your area.</p>
							</div>
							<div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
								<Link className="btn btn-primary" title="Add New FlexiSet" to="/secured/rateshopper/rates/flexi-sets/create">Add New
									Set</Link></div>
						</div>
						<div className="mt-8 flow-root">
							<div className="overflow-x-auto">
								<div className="inline-block min-w-full p-2 align-middle">
									<table className="min-w-full divide-y divide-gray-300 text-gray-500">
										<thead>
										<tr>
											<th scope="col"
													className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">Name
											</th>
											<th scope="col"
													className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Created
											</th>
											<th scope="col"
													className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Listings
											</th>
											<th scope="col"
													className="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">Status
											</th>
											<th scope="col" className="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0"></th>
										</tr>
										</thead>
										<tbody className="divide-y divide-gray-200 bg-white align-top">
										{competitorGroups!.map((competitorGroup) => <tr>
											<td className="whitespace-nowrap py-3 pl-4 pr-3 sm:pl-0 text-sm font-medium text-gray-900">
												{competitorGroup.name}
											</td>
											<td
												className="whitespace-nowrap px-2 py-3 text-sm">{Utilities.formatDateString(competitorGroup.creationDate, 'DD/MM/YYYY HH:mm')}</td>
											<td className="whitespace-nowrap px-2 py-3 text-sm">{competitorGroup.competitors.length}</td>
											<td className="whitespace-nowrap px-2 py-3 text-sm"><span
												className="inline-flex flex-shrink-0 items-center rounded-lg bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">Active</span>
											</td>
											<td className="relative whitespace-nowrap py-3 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
												<div className="flex flex-shrink-0 justify-end space-x-3">
													<div>
														<a className="text-red-600 font-semibold hover:text-red-900 cursor-pointer"
															 onClick={() => deleteDialogue.open(competitorGroup.id)}>Delete</a>
														<span className="mx-2">|</span>
														<Link className="text-blue-600 font-semibold hover:text-blue-900"
																	to={`/secured/rateshopper/rates/flexi-sets/${competitorGroup.id}`}>Open</Link>
													</div>
												</div>
											</td>
										</tr>)}

										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
					<Dialogue ref={deleteDialogue.ref} title="Delete FlexiSet"
										onConfirm={() => onRemoveCompanyHotelCompetitorsGroup(deleteDialogue.getValue()!)}>
						Are you sure you want to delete this Flexi Set?
					</Dialogue>
				</div>}

			{_isEmpty(competitorGroups) && <div className="mt-8">
				<Link
					className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
					to="/secured/rateshopper/rates/flexi-sets/create">
					<DocumentPlusIcon className="mx-auto h-12 w-12 text-gray-400" />
					<span className="mt-2 block text-sm font-semibold text-gray-900">Create a new FlexiSet</span>
				</Link>
			</div>}
		</div>
	</main>;
});

export default FlexiSetsPage;